module.exports = __webpack_public_path__ + "media/customizations/crosscreek/back-85c841a4ea099e9b2c682e45aabcfaf0.jpg";